import { Box } from '@material-ui/core'
import stepper1 from '../../images/stepper/stepper1.svg'
import stepper2 from '../../images/stepper/stepper2.svg'
import stepper3 from '../../images/stepper/stepper3.svg'
import stepper4 from '../../images/stepper/stepper4.svg'

const getStepDescription = (currentStep, status) => {
  return steps[currentStep].description
}
const SUBMITTED = 'submitted'
const APPROVED = 'approved'
const REJECTED = 'rejected'
const REPORTGENERATED = 'report_generated'

const stepsText = ['Download Program Documents', 'Submit Application for Enphase Review', 'Application approved/ rejected by Enphase', 'Evidence report mailed']

const steps = [
  {
    img: stepper1,
    description: 'Download T&C Document and get them signed from homeowner.',
  },
  {
    img: stepper2,
    description: 'Fill homeowner details, upload signed T&C document and application summary document received from HECO here. Once done, submit the application for Enphase review.',
  },
  {
    img: stepper3,
    description: 'Enphase either approves or rejects the application. In case of rejection, you can view the reason for rejection and re-submit the application.'
  },
  {
    img: stepper4,
    description: <>
      <Box>{'Good Job! Once approved by Enphase, the site is successfully enrolled in the program. Homeowner’s battery will discharge during the dispatch timings to gather the 7 days Verification Evidence for the site. Once ready, Verification Evidence Report will be mailed to Installer.'}</Box>
    </>
  }
]

const labelMapper = {
  [APPROVED]: 'Application approved by Enphase',
  [REJECTED]: 'Application rejected by Enphase',
}

const stepsMapper = {
  [REJECTED]: 'Application approved/ rejected by Enphase'
}

const stepperMapper = {
  [APPROVED]: 'Application approved/ rejected by Enphase',
  [REJECTED]: 'Application approved/ rejected by Enphase',
}

const getLabel = (label, status) => {
  if (stepperMapper[status] === label && (status === APPROVED || status === REJECTED)) {
    return labelMapper[status]
  }
  return label
}

export {
  stepsText,
  steps,
  stepsMapper,
  getStepDescription,
  getLabel
}